const hexToUint8Array = (hex: string) => {
  return new Uint8Array(
    hex.match(/.{1,2}/g)!.map((byte) => parseInt(byte, 16))
  );
};

const uint8ArrayToHex = (bytes: Uint8Array) => {
  return Array.from(bytes)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};

const getKey = async (secretKey: string) => {
  const keyBuffer = hexToUint8Array(secretKey); // Convert hex to Uint8Array
  return await crypto.subtle.importKey(
    'raw',
    keyBuffer,
    { name: 'AES-CBC' },
    false,
    ['encrypt', 'decrypt']
  );
};

export const encrypt = async (text: string, secretKey: string) => {
  const key = await getKey(secretKey);
  const iv = crypto.getRandomValues(new Uint8Array(16));
  const encodedText = new TextEncoder().encode(text);

  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: 'AES-CBC', iv },
    key,
    encodedText
  );

  return `${uint8ArrayToHex(iv)}:${uint8ArrayToHex(new Uint8Array(encryptedBuffer))}`;
};

export const decrypt = async (encryptedText: string, secretKey: string) => {
  try {
    const [ivHex, encryptedHex] = encryptedText.split(':');
    const iv = hexToUint8Array(ivHex);
    const encryptedData = hexToUint8Array(encryptedHex);

    const key = await getKey(secretKey);
    const decryptedBuffer = await crypto.subtle.decrypt(
      { name: 'AES-CBC', iv },
      key,
      encryptedData
    );

    return new TextDecoder().decode(decryptedBuffer);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};
